'use strict'

import fetch from 'isomorphic-fetch'
import LocalStorage from './localStorage'

const APIFY_URL = 'https://api.ipify.org'
const API_URL = process.env.API_URL || 'http://localhost:4000'
const GET_CURRENCIES = `${API_URL}/getCurrencies`
const GET_RATES = `${API_URL}/getRates`
const GET_IP_INFO = `${API_URL}/getIpInfo`

export const fetchCurrencies = async () => {
  const currencies = LocalStorage.getItem('currencies')
  if (currencies) {
    return { currencies }
  } else {
    try {
      const response = await fetch(GET_CURRENCIES)
      const data = await response.json()
      LocalStorage.setItem('currencies', data)
      return { currencies: data }
    } catch (err) {
      return { error: 'Failed to fetch currencies' }
    }
  }
}

export const fetchRates = async () => {
  const rates = LocalStorage.getItem('rates')
  if (rates) {
    return { rates }
  } else {
    try {
      const response = await fetch(GET_RATES)
      const data = await response.json()
      LocalStorage.setItem('rates', data)
      return { rates: data }
    } catch (err) {
      return { error: 'Failed to fetch rates' }
    }
  }
}

export const fetchIpInfo = async () => {
  const ipInfo = LocalStorage.getItem('ipInfo')
  if (ipInfo) {
    return { ipInfo }
  } else {
    try {
      let response = await fetch(APIFY_URL)
      const ipAddress = await response.text()
      response = await fetch(`${GET_IP_INFO}?ip=${ipAddress}`)
      const json = await response.json()
      LocalStorage.setItem('ipInfo', json)
      return { ipInfo: json }
    } catch (err) {
      return { error: 'Failed to fetch currencies' }
    }
  }
}
